var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("report-base", {
        attrs: {
          title: "Sales Report",
          "table-class": "analytics-tables--sales",
          subject: "sales",
          items: _vm.sales,
          fields: _vm.fields,
          "is-loading": _vm.loading,
        },
        on: { reload: _vm.loadData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }